import {
  ComponentStyleConfig,
  createMultiStyleConfigHelpers,
} from '@chakra-ui/react';
import * as anatomy from '@chakra-ui/anatomy';

const { definePartsStyle } = createMultiStyleConfigHelpers(
  anatomy.radioAnatomy.keys,
);

const baseStyle = definePartsStyle({
  control: {
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    borderColor: 'neutral.600',
    _checked: {
      background: 'white.500',
      borderColor: 'neutral.600',
      color: 'neutral.600',
      _before: {
        width: '12px',
        height: '12px',
      },
      _hover: {
        background: 'white.500',
        borderColor: 'neutral.600',
      },
    },
  },
});

export const Radio: ComponentStyleConfig = {
  baseStyle,
};
